/**
 * @description 全施設ページ作成後に一覧リンク追加指示受け、面倒がすぎるのでjsで対応.
 */

export const addFirstLayerUrl = () => {
  const target = $('.js-add-firstlayerurl');
  if (!target.length) return;

  target.each((i, e) => {
    const reg = new RegExp('https?://.*?/(.*?)(?=/)');
    const firstLayer = location.href.match(reg)![1];
    const link = $(e).attr('href');

    $(e).attr('href', `/${firstLayer}${link}`);
  });
};
